import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponent } from '../../components/shared/header/header.component';
import { MainBannerComponent } from './components/main-banner/main-banner.component';
import { PlatformBannerComponent } from './components/platform-banner/platform-banner.component';
import { PlansBannerComponent } from './components/plans-banner/plans-banner.component';
import { FooterComponent } from '../../components/shared/footer/footer.component';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    HeaderComponent,
    MainBannerComponent,
    PlatformBannerComponent,
    PlansBannerComponent,
    FooterComponent,
  ],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {}
